import React, { useEffect, useState } from "react";
import "./BackToTop.css";
import { FaArrowUp } from "react-icons/fa";

export default function BackToTop(){

const [visible,setVisible]=useState(false);

useEffect(()=>{

const handleScroll=()=>{

setVisible(window.scrollY>350);

};

window.addEventListener("scroll",handleScroll);

return()=>window.removeEventListener("scroll",handleScroll);

},[]);

const scrollTop=()=>{

window.scrollTo({

top:0,

behavior:"smooth"

});

};

if(!visible) return null;

return(

<button
className="zetech-back-top"
onClick={scrollTop}
aria-label="Back to Top">

<span className="zetech-top-tooltip">

Back to Top

</span>

<FaArrowUp/>

</button>

);

}